import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import style from './UserComments.module.scss';
import {
  BrassBadge,
  BrassBadgeContainer,
  BrassButton,
  BrassIcon,
} from '../../../../..';
import { faBell, faComments } from '@fortawesome/free-solid-svg-icons';
import {
  NotificationService,
  UserNotificationCount,
} from '../../../../../../modules/notification';
import { ApiResult, ModuleUrlEnum } from '../../../../../../models';
import { redirectPlatform } from '../../../../../../util';
import { EnvironmentService } from '../../../../../../services';
import { MainLayoutContainerContext } from '../../MainLayoutContainer';

const UserComments: FunctionComponent = () => {
  const navigate = useNavigate();
  const {
    commentCount,
    setCommentCount,
    isPulsingComment,
    setIsPulsingComment,
    handleCountComments,
  } = useContext(MainLayoutContainerContext);

  useEffect(() => {
    handleCountComments && handleCountComments();
  }, []);

  return (
    <BrassBadgeContainer>
      <BrassButton
        fillMode='flat'
        onClick={(): void => {
          setCommentCount && setCommentCount(0);
          setIsPulsingComment && setIsPulsingComment(false);

          const actualPlatform = EnvironmentService.app;

          if (actualPlatform == ModuleUrlEnum.CONNECT) {
            if (navigate) {
              navigate('/home/#comments');
              return;
            }
          }

          redirectPlatform(ModuleUrlEnum.CONNECT, 'home/#comments');
        }}
        className={isPulsingComment ? style.alert : ''}
      >
        <BrassIcon icon={faComments} size='2x' color='white' />
        {((commentCount && Number(commentCount) > 0) || commentCount === '99+') && (
          <BrassBadge
            align={{ vertical: 'top', horizontal: 'end' }}
            position='edge'
            themeColor='error'
            style={{
              margin: '12px 6px 0 0',
              fontSize: '0.7rem !important',
              zIndex: 0,
            }}
          >
            {commentCount}
          </BrassBadge>
        )}
      </BrassButton>
    </BrassBadgeContainer>
  );
};

export { UserComments };
